import { RESULT_TYPE } from '@savgroup-front-common/types';

export const SEARCH_HEIGHT = {
  RESULT: 52,
  TITLE: 32,
  CONTROLS: 32,
  SHOW_MORE_RESULT: 52,
  ERROR: 52,
  NO_RESULT: 260,
};

export const SEARCH_RESULT_ORDER = [
  RESULT_TYPE.ORDER,
  RESULT_TYPE.FILE,
  RESULT_TYPE.SPARE_PART_REQUEST,
  RESULT_TYPE.STOCK_ITEM,
];

export const defaultSearchResultTypePermissions = [
  RESULT_TYPE.ORDER,
  RESULT_TYPE.FILE,
  RESULT_TYPE.SPARE_PART_REQUEST,
  RESULT_TYPE.STOCK_ITEM,
];

export const RESULTS_COUNT_DISPLAYED = 12;
